import React, { useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { isUserAdmin, isUserClaimGroupConsultant } from '../util/user/userUtils';
import { REVIEW_TYPE_CONSULTANT } from '@rd-web-markets/shared/dist/util/constants';
import { Button } from '../util/buttons';
import StartReviewButton from '../util/buttons/StartReviewButton';
import AssignChangeSetModal from '@components/shared/managerReviews/AssignChangeSetModal';
export default function ButtonControls(_ref) {
  let {
    canShowStartTrackingChangesButton = true,
    company,
    claimGroup,
    reviewedObject,
    reviewedObjectClass,
    loading,
    createChangeSet,
    finalizeChangeSet,
    approveChangeSet,
    rejectChangeSet,
    buttonName,
    setModalShow,
    underManagerReviewButtonName = 'Under Manager Review',
    managerQAReviewButtonName = 'manager_review_completed',
    acceptChangesButtonText = 'accept_manager_review_changes',
    rejectChangesButtonText = 'reject_manager_review_changes',
    reviewType = REVIEW_TYPE_CONSULTANT,
    disabledBeforeManagerReview = false,
    showReportTypeSelector = false,
    onReportTypeChange,
    selectedReportType = 'rnd_only'
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const handleReportTypeChange = e => {
    const value = e.target.value;
    if (onReportTypeChange) {
      onReportTypeChange(value);
    }
  };
  const renderButton = () => {
    const differentReviewStarted = reviewedObject.active_change_set && reviewedObject.active_change_set.review_type !== reviewType;
    const reviewHasNotBeenStartedAndUserHasPrivileges = !reviewedObject.active_change_set && (isUserClaimGroupConsultant(user, reviewedObject) || isUserAdmin(user));
    const createChangeSetOrOpenModal = () => {
      if (process.env.PUBLIC_URL === '/de') {
        createChangeSet(reviewedObject, reviewedObjectClass, reviewType);
      } else {
        setModalShow();
      }
    };
    if (differentReviewStarted || reviewHasNotBeenStartedAndUserHasPrivileges) {
      return canShowStartTrackingChangesButton ? /*#__PURE__*/React.createElement(React.Fragment, null, showReportTypeSelector && /*#__PURE__*/React.createElement(Row, {
        className: "mb-4 justify-content-center"
      }, /*#__PURE__*/React.createElement(Col, {
        md: 6
      }, /*#__PURE__*/React.createElement(Form.Group, null, /*#__PURE__*/React.createElement(Form.Label, {
        className: "fw-bold"
      }, t('select_report_type')), /*#__PURE__*/React.createElement(Form.Select, {
        value: selectedReportType,
        onChange: handleReportTypeChange,
        size: "lg"
      }, /*#__PURE__*/React.createElement("option", {
        value: "rnd_only"
      }, t('rnd_report_only')), /*#__PURE__*/React.createElement("option", {
        value: "cost_only"
      }, t('cost_only')), /*#__PURE__*/React.createElement("option", {
        value: "both"
      }, t('both_rnd_report_and_cost'))), /*#__PURE__*/React.createElement(Form.Text, {
        className: "text-muted"
      }, selectedReportType === 'rnd_only' && t('rnd_only_description'), selectedReportType === 'cost_only' && t('cost_only_description'), selectedReportType === 'both' && t('both_description'))))), /*#__PURE__*/React.createElement(StartReviewButton, {
        text: buttonName,
        loading: loading,
        reviewedObject: reviewedObject,
        reviewedObjectClass: reviewedObjectClass,
        reviewType: reviewType,
        onClick: createChangeSetOrOpenModal,
        disabledBeforeManagerReview: disabledBeforeManagerReview
      })) : null;
    } else if (reviewedObject.active_change_set && !reviewedObject.active_change_set.finalized_at) {
      const canCompleteQAReview = true;
      if (canCompleteQAReview) {
        return /*#__PURE__*/React.createElement(Button, {
          onClick: () => finalizeChangeSet(reviewedObject),
          loading: loading,
          icon: "flag",
          disabled: reviewedObject.is_locked,
          iconPosition: "left",
          variant: "danger",
          size: "md"
        }, t(managerQAReviewButtonName));
      } else {
        return /*#__PURE__*/React.createElement(Button, {
          icon: "flag",
          disabled: true,
          iconPosition: "left",
          variant: "danger",
          size: "md"
        }, underManagerReviewButtonName);
      }
    } else if ((isUserAdmin(user) || isUserClaimGroupConsultant(user, reviewedObject)) && reviewedObject.active_change_set && reviewedObject.active_change_set.finalized_at) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        onClick: () => approveChangeSet(reviewedObject),
        className: "mx-2",
        loading: loading,
        icon: "done",
        disabled: reviewedObject.is_locked,
        iconPosition: "left",
        variant: "success",
        size: "md"
      }, t(acceptChangesButtonText)));
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "mt-5 mb-5"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 12,
    className: "text-center"
  }, renderButton())));
}